module.exports = __webpack_public_path__ + "img/oth8.0fff723d.png";